/**
 * @module M/plugin/ScaleZoom
 */
import 'assets/css/scalezoom';
import 'assets/css/style';
import ScaleZoomControl from './scalezoomcontrol';


export default class ScaleZoom extends M.Plugin {
  /**
   * @classdesc
   * Main facade plugin object. This class creates a plugin
   * object which has an implementation Object
   *
   * @constructor
   * @extends {M.Plugin}
   * @param {Object} impl implementation object
   * @api stable
   */
  constructor(plugin) {
    super();
    /**
     * Facade of the map
     * @private
     * @type {M.Map}
     */
    this.map_ = null;

    /**
     * Array of controls
     * @private
     * @type {Array<M.Control>}
     */
    this.controls_ = [];

    /**
     * @private
     */
    this.plugin_ = plugin;
  }

  /**
   * This function adds this plugin into the map
   *
   * @public
   * @function
   * @param {M.Map} map the map to add the plugin
   * @api stable
   */
  addTo(map) {
    this.controls_.push(new ScaleZoomControl(this.plugin_));
    this.map_ = map;
    // panel para agregar control - no obligatorio
    this.panel_ = new M.ui.Panel('panelScaleZoom', {
      collapsible: false,
      position: M.ui.position.TL,
      collapsedButtonClass: 'g-cartografia-flecha-derecha',
    });
    this.panel_.addControls(this.controls_);
    map.addPanels(this.panel_);
  }

  setState(state) {
    this.state_ = state;
    if (this.controls_[0] instanceof ScaleZoomControl) {
      this.controls_[0].setState(state);
    }
  }

  setCallbackState(callback) {
    this.callbackState_ = callback;
    if (this.controls_[0] instanceof ScaleZoomControl) {
      this.controls_[0].setCallbackState(callback);
    }
  }
}
